<div *ngIf="isLoading" class="loading-indicator">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>
<section class="content-header">
  <div class="mar">
    <div class="card-body" style="display: block">
      <h1 style="font-size: 20px;margin:0px;padding-bottom: 20px;">{{"NEW_ADVERTISER" | translate}}</h1>
     <form name="form" [formGroup]="registerForm" (ngSubmit)="onSubmit()" >
        <div class="row">
          <div class="col-md-4">
            <label for="name">{{"ADVERTISER_NAME" | translate}} </label><br>
            <input type="text"  id='name' formControlName="name" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.name.errors }" />
            <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
              <div  class="err" *ngIf="f.name.errors.required">*{{"NAME_REQUIRED" | translate}}</div>
              <div class="err" *ngIf="f.name.errors.pattern">*{{"ALPHABETS_ONLY" | translate}}  </div>
            </div>
          </div>
         <!--
           <div class="col-md-4">
            <label for="siren">Siren </label><br>
            <input type="text"  id='siren' formControlName="siren" maxlength="9" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.siren.errors }" />
            <div *ngIf="submitted && f.siren.errors" class="invalid-feedback">
              <div  class="err" *ngIf="f.siren.errors.required">*Siren requis</div>
              <div class="err" *ngIf="f.siren.errors.maxlength">*N° siren doit contenir 9 chiffres</div>
              <div class="err" *ngIf="f.siren.errors.minlength">*N° siren doit contenir 9 chiffres</div>
              <div class="err" *ngIf="f.siren.errors.pattern">*Les nombres uniquement (pas d'espaces ou de caractères spéciaux)</div>
            </div>
          </div>
          -->
          <div class="col-md-4">
            <label for="siret">{{"SIRET" | translate}}</label><br>
            <input type="text"  id='siret' formControlName="siret" maxlength="14" (ngModelChange)=onSelectionChanged($event) class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.siret.errors }" />
            <div *ngIf="submitted && f.siret.errors" class="invalid-feedback">
              <div  class="err" *ngIf="f.siret.errors.required">*{{"SIRET_REQUIRED" | translate}}</div>
              <div class="err" *ngIf="f.siret.errors.maxlength">*{{"SIRET_NUMBERS_REQUIRED" | translate}}</div>
              <div class="err" *ngIf="f.siret.errors.minlength">*{{"SIRET_NUMBERS_REQUIRED" | translate}}</div>
              <div class="err" *ngIf="f.siret.errors.pattern">*{{"NUMBERS_ONLY" | translate}}</div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label>{{"CHOOSE_INDUSTRY" | translate}}</label><br>
              <mat-select  class="form-control select2 select2-hidden-accessible"
                           formControlName="industry" [compareWith]="compareFunction" >
                <mat-option disabled >{{"CHOOSE_INDUSTRY" | translate}}</mat-option>
                <mat-option  *ngFor="let industrie of industries" [value]= industrie.value>{{industrie.label}}</mat-option>
              </mat-select>
              <div *ngIf="submitted && f.industry.errors" class="invalid-feedback">
                <div  class="err" *ngIf="f.industry.errors.required">*{{"INDUSTRY_REQUIRED" | translate}}</div>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-4">
            <label for="companyName">{{"COMPANY_NAME" | translate}}</label><br>
            <input type="text"  id='companyName' formControlName="companyName" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.companyName.errors }" />
          </div>

          <div class="col-md-4">
            <label for="address1">{{"ADDRESS1" | translate}}</label><br>
            <input type="text"  id='address1' formControlName="address1" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.address1.errors }" />
                   <div *ngIf="submitted && f.address1.errors" class="invalid-feedback">
                    <div  class="err" *ngIf="f.address1.errors.required">{{"ADDRESS_REQUIRED" | translate}}</div>
                    </div>
          </div>

          <div class="col-md-4">
            <label for="address2">{{"ADDRESS2" | translate}}</label><br>
            <input type="text"  id='address2' formControlName="address2" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.address2.errors }" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="postalCode">{{"POSTAL_CODE" | translate}}</label><br>
            <input type="text"  id='postalCode' formControlName="postalCode" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.postalCode.errors }" />
                   <div *ngIf="submitted && f.postalCode.errors" class="invalid-feedback">
                    <div  class="err" *ngIf="f.postalCode.errors.required">*{{"POSTAL_CODE_REQUIRED" | translate}}</div>
                    </div>

          </div>

          <div class="col-md-4">
            <label for="city">{{"CITY" | translate}}</label><br>
            <input type="text"  id='city' formControlName="city" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
                   <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                    <div  class="err" *ngIf="f.city.errors.required">*{{"CITY_REQUIRED" | translate}}</div>
                    </div>
          </div>

          <div class="col-md-4">
            <label for="country">{{"COUNTRY" | translate}}</label><br>
            <input type="text"  id='country' formControlName="country" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.country.errors }" />
          </div>

        </div>

        <div class="row">
          <div class="col-md-12">
            <label for="file">{{"DOWNLOAD_LOGO" | translate}}</label>
            <input style="margin:auto" formControlName="logo" type="file"
                   id="file"
                   (change)="selectFile($event)">
            <div *ngIf="submitted  && f.logo.errors" class="invalid-feedback">
              <div  class="err" *ngIf="f.logo.errors.required">*{{"LOGO_REQUIRED" | translate}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <label for="crmId">{{"CRM_ID" | translate}}</label><br>
            <input type="text"  id='crmId' formControlName="crmId" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.crmId.errors }" />
          </div>

          <div class="col-md-3">
            <label for="plannerId">{{"PLANNER_ID" | translate}}</label><br>
            <input type="text"  id='plannerId' formControlName="plannerId" class="form-control"
                   [ngClass]="{ 'is-invalid': submitted && f.plannerId.errors }" />
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>Type</label><br>
              <mat-select class="form-control select2 select2-hidden-accessible"
                          formControlName="type" [ngClass]="{ 'is-invalid': submitted && f.type.errors }" >
                <mat-option  *ngFor="let type of clientTypeOptions" [value]="type.value">{{ type.label }}</mat-option>
              </mat-select>
              <div *ngIf="submitted && f.type.errors" class="invalid-feedback">
                <div  class="err" *ngIf="f.type.errors.required">*{{"TYPE_REQUIRED" | translate}}</div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{"COMMERCIAL" | translate}}</label><br>
              <mat-select  class="form-control  select2 select2-hidden-accessible"
                           formControlName="commercial"  [ngClass]="{ 'is-invalid': submitted && f.commercial.errors }" >
                <mat-option disabled >{{"CHOOSE_SALESPERSON" | translate}}</mat-option>
                <mat-option  *ngFor="let comercial of commercials" [value]= comercial.email>{{comercial.name}}</mat-option>
              </mat-select>
              <div *ngIf="submitted && f.commercial.errors" class="invalid-feedback">
                <div  class="err" *ngIf="f.commercial.errors.required">*{{"COMMERCIAL_REQUIRED" | translate}}</div>
              </div>
            </div>
          </div>



        </div>
        <br/>
        <div class="container-sm">
          <button type="button"  (click)="goBack()" class="btn btn-info">{{"BACK" | translate}}</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button  class="btn btn-primary">{{"ADD" | translate}}</button>
        </div>
      </form>
    </div>
  </div>
</section>


